import React, { useState } from 'react';
import './styles';
import { useSelector } from 'react-redux';
import UILabeledInput from '../../UI/UILabeledInput';
import Queries from '../../../utils/API/Queries';
import { PROMOS } from '../../../utils/Config/Constants';
import UIOverlayCard from '../../UI/UIOverlayCard';
import UIIconButton from '../../UI/UIIconButton';
import { UI_LABELED_INPUT_CURRENCY_TYPE, UI_LABELED_INPUT_INVITE_CODE_TYPE } from '../../UI/UILabeledInput/config';
import { getSignedInUserSelector } from '../../../redux/selectors/CurrentUserSelectors';
import { toast } from 'react-toastify';
import { useApolloClient } from 'react-apollo';
import { DISCOUNT_TYPES } from '../../../utils/Helpers/DiscountCalculator/DiscountCalculator';
import { UI_ICON_BUTTON_FILL_TYPE } from '../../UI/UIIconButton/config';

export default function CreateInviteCodeModal({ salesperson, onCreate, hideModal }: CreateInviteCodeModalProps) {
	const signedInUser = useSelector(getSignedInUserSelector);

	const [inviteCode, setInviteCode] = useState<string>('');
	const [creditAmount, setCreditAmount] = useState<number>(0);
	const [isCreatingInviteCode, setIsCreatingInviteCode] = useState<boolean>(false);

	const client = useApolloClient();

	const createInviteCode = async () => {
		if (inviteCode.trim().length === 0) {
			toast.info('Please enter an invite code!');
			return;
		} else if (signedInUser.role === 'affiliate' && (creditAmount < 0 || creditAmount > 2000)) {
			toast.info('Credit amount can be between $1 - $20');
			return;
		}

		setIsCreatingInviteCode(true);

		let promosArray = [
			{
				maxUses: 1,
				uses: 0,
				name: 'Invite Code Promo',
				amount: creditAmount * 100,
				discountAmount: creditAmount * 100,
				discountType: DISCOUNT_TYPES.REDUCTION_AMOUNT,
				promoType: PROMOS.promoTypes.credit
			}
		];

		let variables: any = {
			formType: 'InviteCode',
			inviteCode: inviteCode.toLowerCase(),
			formData: {
				promos: promosArray
			}
		};
		if (salesperson) {
			variables.salesman = salesperson.id;
		}

		const response = await client
			.mutate({
				mutation: Queries.CREATE_FORM_ENTRY,
				variables
			})
			.catch((error) => {
				setIsCreatingInviteCode(false);
				toast.error(error.message);
			});
		const { createForm } = response['data'];
		if (createForm) {
			await onCreate();
			setIsCreatingInviteCode(false);
			hideModal();
		}
	};

	return (
		<UIOverlayCard
			hideModal={hideModal}
			title={'Create an invite code'}
			description={"Choose an invite code, we'll make sure it's unique. All invite codes are case insensitive."}>
			<UILabeledInput
				containerStyle={{ marginTop: 8 }}
				label={'INVITE CODE'}
				type={UI_LABELED_INPUT_INVITE_CODE_TYPE}
				onChangeValue={setInviteCode}
				value={inviteCode}
				placeholder={'Invite code...'}
			/>
			<UILabeledInput
				containerStyle={{ margin: '8px 0 16px 0' }}
				label={'SINGLE USE CREDIT'}
				prefix={'$'}
				type={UI_LABELED_INPUT_CURRENCY_TYPE}
				onChangeNumberValue={setCreditAmount}
				value={creditAmount}
				placeholder={'Credit amount...'}
			/>
			<UIIconButton dark isDisabled={!inviteCode} isLoading={isCreatingInviteCode} type={UI_ICON_BUTTON_FILL_TYPE} text={'create'} onClick={createInviteCode} />
		</UIOverlayCard>
	);
}
